import { actionCreatorFactory } from 'typescript-fsa';

export namespace InfinityDataGridAction {
  const actionCreator = actionCreatorFactory('InfinityDataGrid');

  export const refreshData = actionCreator('REFRESH_DATA');
  export const updateRowCount = actionCreator<number>('UPDATE_ROW_COUNT');
  export const updateSortModel = actionCreator<string[]>('UPDATE_SORT_MODEL');
  export const updateSearch = actionCreator<string | undefined>('UPDATE_SEARCH');

  export const destroy = actionCreator('DESTROY');
}
